module.exports = __webpack_public_path__ + "img/sq5d_01.f1a90544.jpg";